import { render, staticRenderFns } from "./IngredientCost.vue?vue&type=template&id=4c80bcf6&scoped=true"
import script from "./IngredientCost.vue?vue&type=script&lang=ts"
export * from "./IngredientCost.vue?vue&type=script&lang=ts"
import style0 from "./IngredientCost.vue?vue&type=style&index=0&id=4c80bcf6&prod&scoped=true&lang=css"
import style1 from "./IngredientCost.vue?vue&type=style&index=1&id=4c80bcf6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c80bcf6",
  null
  
)

export default component.exports